import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';

export function createCardLectureViews({ dispatch }, { lectureId, params }) {
  return http.post(`${MINERVA_API_URL}/card-lectures/${lectureId}/views`, params);
}

export function fetchCardLecture({ dispatch }, lectureId) {
  return http.get(`${MINERVA_API_URL}/card-lectures/${lectureId}`)
    .then(res => res.data);
}

export function fetchCardLectures({ dispatch }, filters = {}) {
  return http.get(`${MINERVA_API_URL}/card-lectures`, { params: filters })
    .then(res => res.data);
}

export function fetchCardLectureIsLiked({ dispatch }, { lectureId, userId }) {
  return http.get(`${MINERVA_API_URL}/card-lectures/${lectureId}/liked-users/${userId}`)
    .then(() => (true))
    .catch((err) => {
      if (err.response.status === 404) {
        return false;
      }

      return Promise.reject(err);
    });
}

export function createCardLectureLike({ dispatch }, lectureId) {
  return http.post(`${MINERVA_API_URL}/card-lectures/${lectureId}/likes`)
    .then(() => true);
}

export function removeCardLectureLike({ dispatch }, lectureId) {
  return http.delete(`${MINERVA_API_URL}/card-lectures/${lectureId}/likes`)
    .then(() => false);
}

export function fetchCardLectureIsBookmarked({ dispatch }, { lectureId, userId }) {
  return http.get(`${MINERVA_API_URL}/card-lectures/${lectureId}/bookmarked-users/${userId}`)
    .then(() => (true))
    .catch((err) => {
      if (err.response.status === 404) {
        return false;
      }

      return Promise.reject(err);
    });
}

export function createCardLectureBookmark({ dispatch }, lectureId) {
  return http.post(`${MINERVA_API_URL}/card-lectures/${lectureId}/bookmarks`)
    .then(() => true);
}

export function removeCardLectureBookmark({ dispatch }, lectureId) {
  return http.delete(`${MINERVA_API_URL}/card-lectures/${lectureId}/bookmarks`)
  .then(() => false);
}

export function fetchSimilarCardLectures({ dispatch }, { filters, lectureId }) {
  return http.get(`${MINERVA_API_URL}/card-lectures/${lectureId}/similar-lectures`, { params: filters })
    .then(res => res.data);
}



// WEBPACK FOOTER //
// ./src/app/card-lecture/store/actions.js